export interface MonthlyPeriod {
  index: number;
  year: number;
  month: number;
  day?: number;
}

export function StrigifyDatePeriod(date: Date) {
  return `${date.getFullYear()}.${months[date.getMonth()]}.${
    months[date.getDate()]
  }`;
}

export function StringifyMonthlyPeriod(mp: MonthlyPeriod) {
  if (mp.month > 11 || mp.month < 0) return `${mp.year}`;
  return `${mp.year}/${months[mp.month]}`;
}

export function StringifyOnlyMonthlyPeriod(
  mp: MonthlyPeriod,
  inFullWording?: boolean
) {
  if (mp.month > 11 || mp.month < 0) return `${mp.year}`;
  return inFullWording ? `${monthsInFull[mp.month]}` : `${months[mp.month]}`;
}

export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const monthsInFull = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
